<template>
  <div class="strat">

    <!-- ─── Hero ─────────────────────────────────────────────────────────── -->
    <header class="strat__hero">
      <div class="strat__hero-bg"></div>
      <div class="strat__hero-glow"></div>
      <div class="strat__hero-inner">
        <div class="strat__hero-badge">
          <span class="strat__hero-badge-dot"><span class="strat__hero-badge-ping"></span></span>
          {{ $t('home.strategyLabel') }}
        </div>
        <h1 class="strat__hero-title">{{ $t('home.strategyTitle') }}</h1>
        <p class="strat__hero-desc">{{ $t('home.strategyDesc') }}</p>
      </div>
      <div class="strat__hero-wave">
        <svg viewBox="0 0 1440 80" fill="none" preserveAspectRatio="none">
          <path d="M0 80L60 65C120 50 240 20 360 10C480 0 600 0 720 7.5C840 15 960 30 1080 37.5C1200 45 1320 45 1380 45L1440 45V80H0Z" fill="#f2f0ea"/>
        </svg>
      </div>
    </header>

    <!-- ─── 3 Strategy cards ──────────────────────────────────────────────── -->
    <section class="strat__section strat__section--light">
      <div class="strat__shell">
        <div class="strat__cards">
          <div
            v-for="(s, i) in strategies"
            :key="i"
            class="strat__card"
            :class="{ 'strat__card--featured': s.featured }"
          >
            <div class="strat__card-bar"></div>
            <div class="strat__card-inner">
              <div class="strat__card-eyebrow">
                <span>{{ $t(s.labelKey) }}</span>
                <em v-if="s.featured">{{ $t('home.strategyPopular') }}</em>
              </div>
              <h2 class="strat__card-title">{{ $t(s.titleKey) }}</h2>
              <p class="strat__card-desc">{{ $t(s.descKey) }}</p>

              <!-- Return hero -->
              <div class="strat__card-return">
                <span class="strat__card-return-val">{{ s.returnRange }}</span>
                <span class="strat__card-return-label">{{ $t('home.metricReturn') }}</span>
              </div>

              <!-- Metrics -->
              <div class="strat__metrics">
                <div class="strat__metric">
                  <small>{{ $t('home.metricDrawdown') }}</small>
                  <strong class="negative">{{ s.drawdown }}</strong>
                </div>
                <div class="strat__metric">
                  <small>{{ $t('home.metricWinRate') }}</small>
                  <strong>{{ s.winRate }}</strong>
                </div>
                <div class="strat__metric">
                  <small>{{ $t('home.metricSharpe') }}</small>
                  <strong>{{ s.sharpe }}</strong>
                </div>
              </div>

              <!-- Risk -->
              <div class="strat__risk">
                <div class="strat__risk-dots">
                  <i v-for="n in 5" :key="n" :class="['strat__risk-dot', n <= s.riskLevel ? 'active' : '']"></i>
                </div>
                <span>{{ $t(s.riskLabelKey) }}</span>
              </div>

              <!-- Detail list -->
              <ul class="strat__detail-list">
                <li v-for="(item, j) in s.details" :key="j">
                  <i class="fas fa-check-circle"></i>
                  <span>{{ item }}</span>
                </li>
              </ul>

              <button class="strat__cta-btn" @click="goToContact">
                {{ $t('home.startNow') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ─── Comparison table ──────────────────────────────────────────────── -->
    <section class="strat__section strat__section--white">
      <div class="strat__shell">
        <div class="strat__section-header">
          <h2 class="strat__section-title">{{ $t('strategies.compareTitle') }}</h2>
          <div class="strat__divider"></div>
        </div>

        <div class="strat__table">
          <div class="strat__table-head">
            <span>{{ $t('strategies.compareFeature') }}</span>
            <span>{{ $t('strategies.compareConservative') }}</span>
            <span class="strat__table-head--featured">{{ $t('strategies.compareBalanced') }}</span>
            <span>{{ $t('strategies.compareGrowth') }}</span>
          </div>
          <div v-for="(row, i) in compareRows" :key="i" class="strat__table-row">
            <span class="strat__table-label">{{ $t(row.labelKey) }}</span>
            <span>{{ $t(row.cKey) }}</span>
            <span class="strat__table-cell--featured">{{ $t(row.bKey) }}</span>
            <span>{{ $t(row.gKey) }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ─── CTA ───────────────────────────────────────────────────────────── -->
    <section class="strat__cta">
      <div class="strat__shell">
        <p class="strat__cta-text">{{ $t('home.ctaFinalDesc') }}</p>
        <div class="strat__cta-actions">
          <button class="strat__btn strat__btn--primary" @click="goToContact">
            {{ $t('home.ctaFinalBtnPrimary') }}
          </button>
          <a href="https://t.me/songhancapital" target="_blank" rel="noopener noreferrer" class="strat__btn strat__btn--outline">
            {{ $t('home.ctaFinalBtnSecondary') }}
          </a>
        </div>
      </div>
    </section>

  </div>
</template>

<script src="./strategies.js"></script>
<style src="./strategies.scss" lang="scss"></style>
